














import Vue from "vue";
import {triggerEvent} from "../../../../../frontend/helper/customEvents";
import DealArrangement from "./DealArrangement.vue";

export default Vue.extend({
    name: 'DealArrangementOptions',
    components: {
        DealArrangement
    },
    props: {
        arrangementOptions: {
            type: Array,
            required: true
        },
        current: {
            type: Object,
            default: (): any => null
        },
        dealType: {
            type: String,
            required: true
        },
        displayType: {
            type: String,
            default: 'normal'
        }
    },
    methods: {
        setArrangement(arrangementOption: any) {
            if ( arrangementOption.alerts && arrangementOption.alerts.dialog !== undefined ) {
                triggerEvent('dealDetail-toggleAlert', arrangementOption.alerts.dialog );
                return;
            }
            if ( arrangementOption.alerts && arrangementOption.alerts.reset_calendar !== undefined ) {
                var alert = arrangementOption.alerts.reset_calendar;
                alert.callback = (action: any) => {
                    if (action) {
                        this.$emit('reset-calendar');
                    }
                }
                triggerEvent('dealDetail-toggleAlert', alert );
                return;
            }

            this.$emit('select', arrangementOption);
        }
    },
    computed: {
        isDisplayTypeTitle(): boolean {
            return this.displayType === 'title';
        }
    }
});
